'use es6';

import tinymce from 'tinymce';
import { HS_CORE } from '../constants/plugins';
import initTransformerPlugin from './plugins/transformer';
import initPaddingPlugin from './plugins/padding';
import initDirectionalityPlugin from './plugins/directionality';
import initUsagePlugin from './plugins/usage';
import initSanitizePlugin from './plugins/sanitize';
import initApiPlugin from './plugins/api';
import initContextualToolbarCore from './contextualToolbar';
import initForcePNewlinePlugin from './plugins/newline';

// Hack to trick tinymce to NOT try to load the default icon pack.
// Trying to load the pack results in a failed fetch which causes
// subsequent editors on a page to not have their theme loaded.
if (tinymce.IconManager) {
  tinymce.IconManager.add('default', {
    icons: {}
  });
}
function corePlugins(editor) {
  initTransformerPlugin(editor);
  initPaddingPlugin(editor);
  initDirectionalityPlugin(editor);
  initUsagePlugin(editor);
  initSanitizePlugin(editor);
  initContextualToolbarCore(editor);
  initForcePNewlinePlugin(editor);
  return {
    api: initApiPlugin(editor)
  };
}
tinymce.PluginManager.add(HS_CORE, corePlugins);